import { TooltipContentType } from 'components/QuoteCard';
import {
  DATTooltipConstructor,
  hasDATTooltipContent,
} from 'components/QuoteCard';
import { QuickQuoteResponseQuote } from 'lib/api/getQuickQuote';

import { DATQuoteLocationType, QuoteTypeInSource } from '../types';

type BuildDATTooltipFieldsProps = {
  quote: QuickQuoteResponseQuote;
  qType: QuoteTypeInSource;
  isMultiStop: boolean;
  stops: TooltipContentType['stops'];
  stopFeeUSDMedium?: number;
};

export function buildDATTooltipFields({
  quote,
  qType,
  isMultiStop,
  stops,
  stopFeeUSDMedium,
}: BuildDATTooltipFieldsProps) {
  const tooltipContent: TooltipContentType = {
    typeInSource: qType,
    isMultiStop,
    stops,
    timeframe: quote.metadata?.timeframe || '',
    originName: quote.metadata?.originName || '',
    originType: quote.metadata?.originType || DATQuoteLocationType.REGION,
    destinationName: quote.metadata?.destinationName || '',
    destinationType:
      quote.metadata?.destinationType || DATQuoteLocationType.REGION,
    reports: quote.metadata?.reports || 0,
    companies: quote.metadata?.companies || 0,
    stopFeeUSDMedium: stopFeeUSDMedium ?? undefined,
    datMileage: quote.metadata?.datMileage,
    pcmilerMileage: quote.metadata?.pcmilerMileage,
  };

  if (!hasDATTooltipContent(tooltipContent)) {
    return {};
  }

  return {
    tooltipContent,
    tooltipConstructor: DATTooltipConstructor,
  };
}
